




















































import { Component, Mixins } from "vue-property-decorator";
import { IAuthenticationDialogCondition } from "./IAuthenticationDialogCondition";
import { ImelessTextarea } from "../../system";
import { AuthenticationDialogMixin } from "./mixins";
import { IAuthenticatableAsynchronously } from "./IAuthenticatableAsynchronously";

@Component({
  components: {
    ImelessTextarea,
  },
})
export default class AuthenticationDialog extends Mixins(AuthenticationDialogMixin) implements IAuthenticatableAsynchronously {
  $refs!: {
    userIdImelessTextarea: ImelessTextarea,
    userIdInput: HTMLInputElement,
    passwordImelessTextarea: ImelessTextarea,
    passwordInput: HTMLInputElement,
  };

  async show(): Promise<void> {
    return this.showModal(async () => {
      this.result = false;
      this.userId = this.id;
      this.password = "";
      this.$nextTick(() => {
        if (this.userId) {
          this.focusToPassword();
        } else {
          this.focusToId();
        }
      });
      await this.waitHidden();
      if (!this.result) {
        throw new Error();
      }
    });
  }

  focusToId(): void {
    if (this.shouldUseImelessTextarea) {
      this.$refs.userIdImelessTextarea.getEditor().focus();
    } else {
      this.$refs.userIdInput.focus();
    }
  }

  focusToPassword(): void {
    if (this.shouldUseImelessTextarea) {
      this.$refs.passwordImelessTextarea.getEditor().focus();
    } else {
      this.$refs.passwordInput.focus();
    }
  }

  async authenticate(): Promise<void> {
    try {
      await this.authenticateBy(this.userId, this.password);
      this.result = true;
      this.isVisible = false;
    } catch (e) {
      this.$warn(
        "認証失敗",
        "認証に失敗しました。アカウントとパスワードを確認してください。",
      );
      this.password = "";
      this.focusToPassword();
    }
  }

  async selectOptionConditionally(condition: IAuthenticationDialogCondition): Promise<void> {
    this.id = !condition.userCode ? "" : condition.userCode;
    this.orderUserId = !condition.orderUserCode ? null : condition.orderUserCode;
    this.attendingUserId = !condition.attendingUserCode ? null : condition.attendingUserCode;
    this.doAuthenticate = !condition.doAuthentication ? null : condition.doAuthentication;
    await this.show();
  }
}
